import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import cx from 'classnames';
import _ from 'lodash';
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";


import { padNumber } from 'services/util';
import { convertDatesToTimezone } from 'services/report.service';

import styles from '../workspaceReports.module.scss';
import { EmptyMessage, LoadingMessage, TableInfo, WorkspaceMetricsHeader } from '../../reports/components';
import { TableFooter } from '../../reports/components/tableFooter';
import { DropdownFilter } from '../../reports/components/dropDown';
import { TrendsPieChart } from '../../reports/components/charts';
import { fetchChartMetricsForType, fetchPageMetricsForType } from 'actions/workspaceReports';
import { formatDurationWithLabel, safeDivide } from '../../reports/reporthelpers';

export function WorkspaceMetricsAnalytics(props) {
  const dispatch = useDispatch();

  const metrics = useSelector(state => _.get(state, `workspaces.reports.metrics.${props.metricType}.items`));
  const chartData = useSelector(state => _.get(state, `workspaces.reports.metrics.${props.metricType}.chartItems`));
  const pagination = useSelector(state => _.get(state, `workspaces.reports.metrics.${props.metricType}.pagination`));
  const loading = useSelector(state => _.get(state, `workspaces.reports.metrics.${props.metricType}.loading`));
  const [currentChart, setCurrentChart] = useState("table_view");
  const [viewOption, setViewOption] = useState({ label: 'Views', value: 'views', name: props.tableName === 'Account Analytics'? 'organization.name' : 'metricType' })

  const handleChartChange = (value) => {
    setCurrentChart(value)
  }

  useEffect(() => {
    if (props.date || (props.contentType && props.contentType.length > 0)) {
      handlePageChange(0, props.metricType);
    }
  }, [props.date, props.contentType]);

  const handlePageChange = (page, type) => {
    handleMetricViewsReport(page, type);
  }

  const handleMetricViewsReport = (page, type) => {
    var request = {
      metricType: type,
      ...convertDatesToTimezone(props.date),
      types: props.contentType,
    }

    dispatch(fetchChartMetricsForType(request, 0, 6));
    dispatch(fetchPageMetricsForType(request, page, 5));
  }

  const handleArrange = (data) => {
    setViewOption(state =>{
      return {
        ...state,
        label: data.label,
        value: data.value
      }
    });
  }

  return (
    <div className={styles.workspaceMetricsAnalyticsWrapper}>
      <div className={styles.metricsAnalyticsContainer}>
        <TableInfo
          name={props.tableName}
          pagination={pagination} />

        {currentChart == "table_view" && <WorkspaceMetricsHeader label={props.label} />}

        {currentChart == "pie_chart_view" && <DropdownFilter disableOption={[]}  arrangeOption={viewOption} handleArrange={handleArrange} />}

        {currentChart == "table_view" &&
          !loading && metrics && metrics.map((data, index) => {
            return <MetricsReportView loading={loading} type={props.metricType} data={data} index={index} />
          })
        }

        {(_.size(chartData) > 0  && currentChart == "pie_chart_view") &&
          <div className={styles.graphSmallView}>
            <TrendsPieChart data={chartData} viewOption={viewOption} height={320} width="100%" />
          </div>
        }

        {loading && (metrics && metrics.length > 0) &&
          <LoadingMessage />
        }

        {( metrics && metrics.length == 0) && !loading &&
          <EmptyMessage />
        }
      </div>

      <TableFooter
        currentChart={currentChart}
        disableView={['graph_view']}
        handleChartChange={handleChartChange}
        handlePageChange={(page) => handlePageChange(page, props.metricType)}
        pagination={pagination}
        leftAlign={true}
        paginationName={props.paginationName}
      />
    </div>
  )
}

function MetricsReportView({ loading, type, data }) {

  const [tooltip, setTooltip] = useState(false);
  
  if (!data || data.length <= 1) {
    return false;
  }

  const renderOrganizationName = (data) => {
    if (data.organization) {
      return data.organization.name;
    }

    if (data.contact && data.contact.company) {
      return capitalizeFirstLetter(data.contact.company);
    }

    return renderCompanyNameFromEmail(data.contact.email);
  }

  const capitalizeFirstLetter = (value) => {
    if (value) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }

    return value;
  }

  const renderCompanyNameFromEmail = (email) => {
    const domain = email.split("@")[1];
    const company = domain.split(".")[0];
    return capitalizeFirstLetter(company)
  }

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  return (
    <div className={styles.metricsAnalyticsRow}>
      <div className={cx(styles.metricswrapper, styles.metricsNameColumn)}>
        <div className={styles.headline}>
        <Tooltip placement="top" disabled={!tooltip} content={type == "organization" ? renderOrganizationName(data) : data.metricType}>
          <Truncate onTruncate={handleTooltip} width={90} lines={1}>
            {type == "organization" ? renderOrganizationName(data) : data.metricType}
          </Truncate>
        </Tooltip>
        </div>
      </div>

      <div className={cx(styles.metricswrapper, styles.viewsColumn)}>
        <div className={styles.headline}>{data.views}</div>
      </div>

      <div className={cx(styles.metricswrapper, styles.visitorsColumn)}>
        <div className={styles.headline}>{data.visitors}</div>
      </div>

       <div className={cx(styles.metricswrapper, styles.leadsColumn)}>
        <div className={styles.headline}>{data.leads}</div>
      </div>

      <div className={cx(styles.metricswrapper, styles.timeSpentColumn)}>
        <div className={styles.headline}>{formatDurationWithLabel(data.timeSpent).value}</div>
      </div>

      <div className={cx(styles.metricswrapper, styles.bounceRateColumn)}>
        <div className={styles.headline}> {formatDurationWithLabel(safeDivide(data.timeSpent, data.views)).value}</div>
      </div>
      <div className={cx(styles.metricswrapper, styles.bounceRateColumn)}>
        <div className={styles.headline}>{`${Math.round(data.bounceRate)}%`}</div>
      </div>
    </div>
  )
}